/* eslint-disable no-console */
import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import { StyledModal } from "../LogWorkoutCategoryV2/styles";
import PropTypes from "prop-types";
import {AboutEventPopUpDescription} from './SingleEventV2/styles';
import {Description} from "./styles";
import { Interweave } from 'interweave';
import { withTranslation } from 'react-i18next';
import { NewCloseIconForEvents, NewDividerForEvents } from '../../utils/icons';
class AboutTheEventModal extends Component {

  render() {
    const { onHide, showModal, title, body, t } = this.props;
    return (
      <StyledModal customWidth="600px" show={showModal} change={0} onHide={() => onHide()} transform={0} headerPadding="0" bodyPadding="0">
        <div className={'modal-container'}>
          <div className={'left-modal'}>
            <div className={'text'}>
              {t("About the Event")}
            </div>
          </div>
          <div style={{ "cursor": "pointer"}} onClick={(event) => onHide(event)}>
            <NewCloseIconForEvents/>
          </div>
        </div>
        <div style={{width: "100%", padding: 0, margin: 0}}>
          <NewDividerForEvents/>
        </div>
        {/* <div
          style={{
            width: "100%",
            height: "2px",
            background: "#EFEFEF",
            marginLeft: "-24px",
            marginRight: "-24px",
          }}
        /> */}
        <Modal.Body>
          <AboutEventPopUpDescription customPadding="0">
            <span>
              {t(title)}
            </span>
            <Description padding={1} textAlign={1}>
              <Interweave content={t(body)} />
            </Description>
          </AboutEventPopUpDescription>
        </Modal.Body>
      </StyledModal>
    );
  }
}

AboutTheEventModal.propTypes = {
  showModal: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string,
  history: PropTypes.object,
  body: PropTypes.object,
  t: PropTypes.func
};

export default (withTranslation()(AboutTheEventModal));
